"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vobModal = exports.extendedVobModal = exports.commonFields = void 0;
var Yup = __importStar(require("yup"));
exports.commonFields = {
    // Note: All validation of ".min(1) effectively makes the field required without using ".required(). Does so silently without adding a "Required" message. Only needed for fields that don't need add'l validation
    REQUIRED_STRING: Yup.string().min(1),
    FIRST_NAME: Yup.string().min(1).max(50, 'Must be 50 characters or less'),
    MIDDLE_NAME: Yup.string(),
    LAST_NAME: Yup.string().min(1).max(50, 'Must be 50 characters or less'),
    PATIENT_NAME_OPT: Yup.string()
        .min(0)
        .max(50, 'Must be 50 characters or less'),
    EMAIL: Yup.string().min(1).email('Email Format is Invalid'),
    RETYPE_EMAIL: Yup.string().oneOf([Yup.ref('email'), null], 'Email and Email Confirm must Match'),
    DATE: Yup.string().min(1),
    OPTIONAL_DATE: Yup.string().nullable(),
    ROUTING_NUMBER: Yup.string().matches(/[\d]{2}-?[\d]{7}/, 'Invalid Routing Number Format'),
    ACCOUNT_NUMBER: Yup.string().matches(/[\d]{5,17}/, 'Invalid Account Format'),
    RETYPE_ACCOUNT_NUMBER: Yup.string().oneOf([Yup.ref('accountNumber'), null], 'Account Mismatch'),
    ONLY_NUMERIC_VALUES: Yup.string()
        .min(1)
        .matches(/^[0-9]*([.][0-9]*)?$/, 'Invalid number'),
    REQUIRED_NUMBER_VOB: Yup.number()
        .nullable(true)
        .required('This field is required'),
    REQUIRED_NUMBER: Yup.number().required('This field is required'),
    REQUIRED_POSITIVE_NUMBER: Yup.number()
        .positive('Must be a positive number')
        .required('This field is required'),
    REQUIRED_POSITIVE_NUMBER_ZERO_INCLUSIVE: Yup.number()
        .min(0, 'Must be a positive number')
        .required('This field is required'),
    NOT_REQUIRED_NULLABLE_NUMBER: Yup.number()
        .nullable(true)
        .notRequired()
        .transform(function (_, val) { return (val === Number(val) ? val : null); }),
    IN_NETWORK_INDIVIDUAL_POLICY_ITEM: Yup.number()
        // .nullable(true)
        // .transform((_, val) => (val === Number(val) ? val : null))
        .when('policyInNetwork', {
        is: true,
        then: function (schema) { return schema.required("This field is required"); },
        otherwise: function (schema) { return schema.notRequired(); }
    }),
    OUT_OF_NETWORK_INDIVIDUAL_POLICY_ITEM: Yup.number()
        .transform(function (_, val) { return (val === '' ? undefined : val); })
        .when('policyInNetwork', {
        is: false,
        then: function (schema) { return schema
            .required("This field is required")
            .typeError("This field is required"); },
        otherwise: function (schema) { return schema.notRequired(); }
    }),
    IN_NETWORK_FAMILY_POLICY_ITEM: Yup.number()
        .nullable(true)
        .notRequired()
        .transform(function (_, val) { return (val === Number(val) ? val : null); }),
    OUT_OF_NETWORK_FAMILY_POLICY_ITEM: Yup.number()
        .nullable(true)
        .notRequired()
        .transform(function (_, val) { return (val === Number(val) ? val : null); }),
};
exports.extendedVobModal = {
    policyNum: Yup.number()
        .nullable(true)
        .notRequired()
        .transform(function (_, val) { return (val === Number(val) ? val : null); }),
    groupNum: Yup.number()
        .nullable(true)
        .notRequired()
        .transform(function (_, val) { return (val === Number(val) ? val : null); }),
    payer: Yup.object({
        inNetwork: Yup.boolean().required(),
        payorCode: Yup.number().required(),
        payorId: Yup.string().required(),
        payorName: Yup.string().required()
    }),
    plan: Yup.object({
        facilityPlanId: Yup.number().required(),
        losDays: Yup.number().required(),
        payorPlanId: Yup.number().required(),
        pdrRate: Yup.number().required(),
        planCode: Yup.number().required(),
        planName: Yup.string().required(),
    })
};
exports.vobModal = {
    policyBeginDate: Yup.string().required('From Date is required'),
    policyEndDate: Yup.string().required('Until Date is required'),
    policyInNetwork: Yup.boolean(),
    inNetwDeductible: exports.commonFields.IN_NETWORK_INDIVIDUAL_POLICY_ITEM,
    inNetwDeductibleRemaining: exports.commonFields.IN_NETWORK_INDIVIDUAL_POLICY_ITEM,
    inNetwFamilyDeductible: exports.commonFields.IN_NETWORK_FAMILY_POLICY_ITEM,
    inNetwFamilyDeductibleRemaining: exports.commonFields.IN_NETWORK_FAMILY_POLICY_ITEM,
    inNetwOopMax: exports.commonFields.IN_NETWORK_INDIVIDUAL_POLICY_ITEM,
    inNetwOopMaxRemaining: exports.commonFields.IN_NETWORK_INDIVIDUAL_POLICY_ITEM,
    inNetwFamilyOopMax: exports.commonFields.IN_NETWORK_FAMILY_POLICY_ITEM,
    inNetwFamilyOopMaxRemaining: exports.commonFields.IN_NETWORK_FAMILY_POLICY_ITEM,
    inNetwVobClassifications: Yup.array().of(Yup.object().shape({
        inNetwork: Yup.boolean(),
        selectedClassification: Yup.object()
            .nullable()
            .optional()
            .when('inNetwork', {
            is: function (inNetwork) { return inNetwork; },
            then: Yup.object()
                .nullable()
                .required('VOB Classifiction is Required'),
        }),
        coPaySelection: Yup.string()
            .optional()
            .when('inNetwork', {
            is: function (inNetwork) { return inNetwork; },
            then: Yup.string().required('Copay selection is required'),
        }),
        coInsurance: exports.commonFields.NOT_REQUIRED_NULLABLE_NUMBER.when(['inNetwork', 'coPaySelection'], {
            is: function (inNetwork, coPaySelection) {
                return (coPaySelection === 'n' || coPaySelection === 'y') && inNetwork;
            },
            then: exports.commonFields.REQUIRED_NUMBER_VOB.min(0, 'Minimum of 0%').max(100, 'Maximum of 100%'),
        }),
        coPay: exports.commonFields.NOT_REQUIRED_NULLABLE_NUMBER.when(['inNetwork', 'coPaySelection'], {
            is: function (inNetwork, coPaySelection) {
                return (coPaySelection === 'y' ||
                    coPaySelection === 'copayonly') &&
                    inNetwork;
            },
            then: exports.commonFields.REQUIRED_NUMBER_VOB,
        }),
        maxDays: exports.commonFields.NOT_REQUIRED_NULLABLE_NUMBER.when(['inNetwork', 'coPaySelection'], {
            is: function (inNetwork, coPaySelection) {
                return (coPaySelection === 'y' ||
                    coPaySelection === 'copayonly') &&
                    inNetwork;
            },
            then: exports.commonFields.REQUIRED_NUMBER_VOB,
        }),
    })),
    ooNetwDeductible: exports.commonFields.OUT_OF_NETWORK_INDIVIDUAL_POLICY_ITEM,
    ooNetwDeductibleRemaining: exports.commonFields.OUT_OF_NETWORK_INDIVIDUAL_POLICY_ITEM,
    ooNetwFamilyDeductible: exports.commonFields.OUT_OF_NETWORK_FAMILY_POLICY_ITEM,
    ooNetwFamilyDeductibleRemaining: exports.commonFields.OUT_OF_NETWORK_FAMILY_POLICY_ITEM,
    ooNetwOopMax: exports.commonFields.OUT_OF_NETWORK_INDIVIDUAL_POLICY_ITEM,
    ooNetwOopMaxRemaining: exports.commonFields.OUT_OF_NETWORK_INDIVIDUAL_POLICY_ITEM,
    ooNetwFamilyOopMax: exports.commonFields.OUT_OF_NETWORK_FAMILY_POLICY_ITEM,
    ooNetwFamilyOopMaxRemaining: exports.commonFields.OUT_OF_NETWORK_FAMILY_POLICY_ITEM,
    ooNetwVobClassifications: Yup.array().of(Yup.object().shape({
        inNetwork: Yup.boolean(),
        selectedClassification: Yup.object()
            .nullable()
            .optional()
            .when('inNetwork', {
            is: function (inNetwork) { return !inNetwork; },
            then: Yup.object()
                .nullable()
                .required('VOB Classifiction is Required'),
        }),
        coPaySelection: Yup.string()
            .optional()
            .when('inNetwork', {
            is: function (inNetwork) { return !inNetwork; },
            then: Yup.string().required('Copay selection is required'),
        }),
        coInsurance: exports.commonFields.NOT_REQUIRED_NULLABLE_NUMBER.when(['inNetwork', 'coPaySelection'], {
            is: function (inNetwork, coPaySelection) {
                return (coPaySelection === 'n' || coPaySelection === 'y') && !inNetwork;
            },
            then: exports.commonFields.REQUIRED_NUMBER_VOB.min(0, 'Minimum of 0%').max(100, 'Maximum of 100%'),
        }),
        coPay: exports.commonFields.NOT_REQUIRED_NULLABLE_NUMBER.when(['inNetwork', 'coPaySelection'], {
            is: function (inNetwork, coPaySelection) {
                return (coPaySelection === 'y' ||
                    coPaySelection === 'copayonly') &&
                    !inNetwork;
            },
            then: exports.commonFields.REQUIRED_NUMBER_VOB,
        }),
        maxDays: exports.commonFields.NOT_REQUIRED_NULLABLE_NUMBER.when(['inNetwork', 'coPaySelection'], {
            is: function (inNetwork, coPaySelection) {
                return (coPaySelection === 'y' ||
                    coPaySelection === 'copayonly') &&
                    !inNetwork;
            },
            then: exports.commonFields.REQUIRED_NUMBER_VOB,
        }),
    })),
};
